import { Component } from '@angular/core';

@Component({
	selector: 'lvr-section',
	template: `
		<ng-content select="lvr-title"></ng-content>
		<ng-content></ng-content>
	`,
})
export class LvrSection {}
